"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var loaderStyle = {
  fontFamily: '\'Roboto\', \'Helvetica Neue\', Arial, Helvetica, sans-serif',
  fontSize: '16px',
  position: 'relative',
  lineHeight: '25px',
  paddingLeft: '35px'
};
var spinnerStyle = {
  content: '',
  boxsizing: 'border-box',
  position: 'absolute',
  left: 0,
  width: '25px',
  height: '25px',
  borderRadius: '50%',
  border: '3px solid #ccc',
  borderTopColor: '#006fde'
};

var InlineLoader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InlineLoader, _React$Component);

  function InlineLoader(props) {
    var _this;

    _classCallCheck(this, InlineLoader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InlineLoader).call(this, props));
    _this.spinner = null;
    _this.rotation = 0;
    _this.rotateStep = _this.rotateStep.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InlineLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.requestAnimationFrame(this.rotateStep);
    }
  }, {
    key: "rotateStep",
    value: function rotateStep() {
      if (!this.spinner) return;
      this.rotation = (this.rotation + 16) % 360;
      this.spinner.style.transform = 'rotate(' + this.rotation + 'deg)';
      window.requestAnimationFrame(this.rotateStep);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", null, _react.default.createElement("div", {
        style: loaderStyle
      }, _react.default.createElement("span", {
        ref: function ref(el) {
          _this2.spinner = el;
        },
        style: spinnerStyle
      }), this.props.message));
    }
  }]);

  return InlineLoader;
}(_react.default.Component);

InlineLoader.propTypes = {
  message: _propTypes.string
};
InlineLoader.defaultProps = {
  message: 'Loading Cobalt...'
};
var _default = InlineLoader;
exports.default = _default;
InlineLoader.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "rotateStep",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "InlineLoader",
  "props": {
    "message": {
      "defaultValue": {
        "value": "'Loading Cobalt...'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};